export default __webpack_public_path__ + "static/media/favicon.e4247344.ico";